import { type ApolloClient } from '@apollo/client';

// Screens show what the cache already has at once, then the server's answer.
export const APOLLO_DEFAULT_OPTIONS: ApolloClient.DefaultOptions = {
  watchQuery: { fetchPolicy: 'cache-and-network' },
};
